module.exports = __webpack_public_path__ + "static/media/cards-about.f10a60d3.jpg";